import * as React from 'react';
import './../Modals.scss';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import InvestorType from 'src/entities/InvestorType';

export interface AccreditationExpiredComponentProps {
  investorType: InvestorType;
  handleChange: (value: string) => void;
  handleSubmit: () => void;
}

const AccreditationExpiredComponent = (props: AccreditationExpiredComponentProps) => {
  return (
    <div className="modal-content investment-funnel-modal">
      <div className="modal-body">
        <div className="row">
          <div className="gap-20"/>
          <p className="featured c-black-text">¿Aún eres Inversor Acreditado?</p>
          <p>
            <strong>Como ha pasado más de 12 meses desde tu última inversión</strong>,
            tienes que confirmarnos que sigues siendo inversor acreditado. Por ello te pedimos que escribas en
            mayúsculas en el espacio de abajo: "<strong>CONFIRMO QUE SOY INVERSOR ACREDITADO</strong>”.
          </p>
          <div className="gap-20"/>
          <div className="col-md-12 text-center">
            <div className="form-control confirmation b-primary-dark">
              <InputContainer
                label=" "
                type="text"
                required={false}
                value={props.investorType.confirmationMessage}
                onChange={(value) => props.handleChange(value.toString())}
              />
            </div>
            <div className="gap-20"/>
            <button
              className="btn btn-secondary btn-lg"
              onClick={() => props.handleSubmit()}
            >
              Volver a acreditarme
            </button>
            <div className="gap-20"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccreditationExpiredComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/AccreditationExpired.component.tsx